/**
 * @deprecated We are moving from the use of `categories` and `rulesets` to a unified set of
 * categories. `ConstituentCategories` should be used moving forward unless legacy usage is
 * needed. Legacy usage of `categories` and `rulesets` should use
 * `LegacyConstituentCategories` and `LegacyConstituentRules`, respectively.
 */
enum LegacyConstituentCategories {
  CATEGORY_BOARD_MEMBER = 'category_board_member',
  CATEGORY_CORPORATION = 'category_corporation',
  CATEGORY_FOUNDATION = 'category_foundation',
  CATEGORY_GOVERNMENT = 'category_government',
  CATEGORY_MEMBER = 'category_member',
  CATEGORY_PARTNER = 'category_partner',
  CATEGORY_RECIPIENT = 'category_recipient',
  CATEGORY_VOLUNTEER = 'category_volunteer',
}

export default LegacyConstituentCategories;
